import { useEffect, useState } from "react";
import axios from "axios";
import Header from "./components/header/Header";
import Sidebar from "./components/sidebar/Sidebar";
import Back from "./components/Back";
import Graph from "./components/Graph";
import { api } from "./utils/api";
import NodeContext from "./utils/NodeContext";

export default function App() {
	const [data, setData] = useState({ nodes: [], links: [] });
	const [selectedNode, setSelectedNode] = useState(null);
	const [primaryNode, setPrimaryNode] = useState(null);
	const [selectedGrouping, setSelectedGrouping] = useState("researcher");
	const [nodeHistory, setNodeHistory] = useState([]);
	const [isOpen, setIsOpen] = useState(true);

	useEffect(() => {
		setNodeHistory((prevState) => [...prevState, selectedNode]);
		async function fetchData() {
			let query = "";
			if (selectedNode) {
				query = `${selectedNode.type}/${selectedNode.id.replace(
					/[a-z-]+/g,
					""
				)}`;
				//Handle focus filters
				if (selectedNode.filters) {
					query += `/${selectedNode.filters.join(",")}`;
				}
			} else {
				query = `${selectedGrouping}`;
			}
			const response = await axios.get(`${api.url}/${api.endpoint}/${query}`);
			setData(response.data);

			//Grab and store the current primary node fron the response for use throughout the app (selectedNode is from previous response and doesn't always have all the data)
			//Note: because focuses drill down, the primary node is the selectedNode and not contained in the most recent response
			if (selectedNode) {
				setPrimaryNode(
					selectedNode.type === "focus" || selectedNode.filters
						? selectedNode
						: response.data.nodes
							.filter((node) => {
								return node.id === selectedNode.id;
							})
							.pop()
				);
			} else {
				setPrimaryNode({});
			}
		}
		fetchData();
	}, [selectedNode, selectedGrouping]);

	return (
		<NodeContext.Provider value={{ primaryNode }}>
			{/*Pass the primary node to the context - context might be overkill here 🤷‍♂️*/}
			<div className="flex flex-wrap relative">
				<Header
					selectedGrouping={selectedGrouping}
					setSelectedGrouping={setSelectedGrouping}
					setSelectedNode={setSelectedNode}
				/>
				<Back
					nodeHistory={nodeHistory}
					setNodeHistory={setNodeHistory}
					setSelectedNode={setSelectedNode}
				/>
				<div className="graph-container">
					<Graph data={data} setSelectedNode={setSelectedNode} isOpen={isOpen} setIsOpen={setIsOpen} />
				</div>
				<Sidebar setSelectedNode={setSelectedNode} isOpen={isOpen} setIsOpen={setIsOpen} />
				{/* {<Zoom />} */}
			</div>
		</NodeContext.Provider>
	);
}
